import { authHeader, handleResponse } from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getFuseAdoptionData({ version, fuseDevice }) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const endPoint = `/api/admin/v1/adoption/${fuseDevice}/${version}`;
  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getAdoptionCSV(analyzer, params) {
  const endPoint = `/api/admin/v1/adoption/csv/${analyzer}?${params}`;
  return fetch(`${BASE_URL}${endPoint}`, {
    method: "GET",
    headers: { "Content-Type": "text/csv", ...authHeader() },
  })
    .then(async (res) => {
      if (!res.ok) {
        const errorText = await res.text();
        const err = new Error(
          errorText || `Failed to fetch CSV: ${res.status}`
        );
        err.status = res.status;
        throw err;
      }

      return res.blob();
    })
    .then((blob) => {
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `${analyzer}-adoption.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
}

export const fuseAdoptionService = {
  getFuseAdoptionData,
  getAdoptionCSV,
};
